// Copyright (c) 2025 Annadaneshwar Yadawad. All rights reserved.
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AdminNotifications from '../components/AdminNotifications';
import LoadingSpinner from '../components/LoadingSpinner';
import { publishNotification } from '../services/notificationService';
import './AdminPushMessage.css';

const AdminPushMessage = () => {
  const isAuthenticated = localStorage.getItem('auth') === 'true';
  const isAdmin = isAuthenticated && localStorage.getItem('isAdmin') === 'true';
  const [message, setMessage] = useState('');
  const [type, setType] = useState('info');
  const [loading, setLoading] = useState(false);

  // Only allow access if user logged in with admin/admin credentials
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      toast.warning('Please enter a message to send');
      return;
    }

    try {
      setLoading(true);
      await publishNotification({ message, type });
      toast.success('Notification sent successfully');
      setMessage(''); // Clear the input after successful send
      setType('info');
    } catch (error) {
      console.error('Failed to send notification:', error);
      toast.error('Failed to send notification: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-push-message">
      <h1 className="admin-page-title">Send Push Notifications</h1>
      <div className="admin-page-content">
        <form onSubmit={handleSubmit} className="notification-form">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Enter notification message..."
            className="notification-input"
            required
          />
          <div className="notification-type-group">
            <label htmlFor="notification-type">Type:</label>
            <select
              id="notification-type"
              value={type}
              onChange={e => setType(e.target.value)}
              className="notification-type-select"
            >
              <option value="info">Info</option>
              <option value="warning">Warning</option>
              <option value="important">Important</option>
            </select>
          </div>
          <button
            type="submit"
            className="send-notification-btn"
            disabled={loading}
          >
            {loading ? (
              <>
                Sending... <LoadingSpinner />
              </>
            ) : (
              'Send Notification'
            )}
          </button>
        </form>
        <AdminNotifications />
      </div>
    </div>
  );
};

export default AdminPushMessage;
